export const defaultPositionErrorMessages = {
    rank: "",
    specialty: "",
    position: "",
};

export const defaultErrorMessages = {
    fullName: "",
    filial: "",
    timexServer: "",
    positions: [{ ...defaultPositionErrorMessages }],
};

export const defaultPosition = {
    position: null,
    rank: "",
    specialty: "",
    salary: "",
};

export const defaultForm = {
    fullName: "",
    fullNameDativeCase: "",
    fullNameGenitiveCase: "",
    citizenship: "",
    lawStatus: "",
    filial: "",
    workerStatus: "",
    workerCharacteristic: "",
    employmentStatus: "",
    schedule: "",
    shiftType: "",
    mentor: "",
    timexServer: "",
    timexNumber: "",
    iikoCode: "",
    depositAmount: "",
    payOnPersonalAccount: false,
    isAbleToWorkInDifferentFilials: false,
    company: "",
    isAbleToWorkRemotely: false,
    positions: [{ ...defaultPosition }],
    hiringDate: "",
    dismissalDate: "",
};
